import { render, staticRenderFns } from "./MonitoramentoWebhooks.vue?vue&type=template&id=8e3dbb74&scoped=true"
import script from "./MonitoramentoWebhooks.vue?vue&type=script&lang=js"
export * from "./MonitoramentoWebhooks.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoWebhooks.vue?vue&type=style&index=0&id=8e3dbb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3dbb74",
  null
  
)

export default component.exports